export const PUSHER_METHOD_TYPES = {
  init: 'pusher_init',
  subscribe: 'pusher_subscribe',
  unsubscribe: 'pusher_unsubscribe',
} as const;

export type PusherMethodType = (typeof PUSHER_METHOD_TYPES)[keyof typeof PUSHER_METHOD_TYPES];

export interface PusherMethodPayloadMap {
  [PUSHER_METHOD_TYPES.init]: { authValue: string };
  [PUSHER_METHOD_TYPES.subscribe]: { channel: string };
  [PUSHER_METHOD_TYPES.unsubscribe]: { channel: string };
}

export type PusherMethod = {
  [K in PusherMethodType]: { eventType: K; eventPayload: PusherMethodPayloadMap[K] };
}[PusherMethodType];

export const isPusherMethod = (eventType?: string): eventType is PusherMethodType =>
  Object.values(PUSHER_METHOD_TYPES).includes(eventType as PusherMethodType);
